import * as angular from 'angular';
import { IComponentOptions } from 'angular';

import { CreateSupportStepperCtrl } from './create-support-stepper.controller';

export const CreateSupportStepperComponent: IComponentOptions = {
  template: require('./create-support-stepper.html'),
  bindings: {
    supportId: '<',
    currentSupport: '=',
    currentSupports: '<',
    currentSchool: '<',
    resolvedSchoolUsers: '<',
    goBackStateOpts: '<',
    studentIds: '<',
    exam: '<',
  },
  controller: CreateSupportStepperCtrl,
};

angular.module('nv.SupportsModule').component('createSupportStepper', CreateSupportStepperComponent);
